import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { NotificationRule, INotificationRuleHttpResponse } from '@app/models/notification-settings';
import { Observable, map } from 'rxjs';

const HttpServiceMethods = {
  NotificationRule: 'NotificationRule'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationRulesService {
  constructor(private httpService: HttpCallService) { }

  public list(): Observable<NotificationRule[]> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationRule)
      .pipe(
        map((res) => res.map((item: INotificationRuleHttpResponse) => NotificationRule.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationRule> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationRule + `/${id}`)
      .pipe(map((item: INotificationRuleHttpResponse) => NotificationRule.adapt(item)));
  }

  public add(notificationRule: NotificationRule) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationRule,
      notificationRule
    );
  }

  public update(notificationRule: NotificationRule) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationRule,
      notificationRule
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.NotificationRule + `/${id}`
    );
  }
}
